import React, { useCallback } from 'react';
import { useAudioContext } from '../context/AudioContext';
import styles from './styles.module.scss';

export enum IconPosition {
  Left,
  Right
}
interface Props {
  className?: string;
  children: React.ReactNode;
  buttonRef?:  React.RefObject<HTMLButtonElement>,
  style?: React.CSSProperties,
  enabled?: boolean;
  click: () => void
}

export default function Button({
  buttonRef,
  children,
  className,
  style,
  enabled = true,
  click 
}: Props): JSX.Element {
  const { playAudio } = useAudioContext(); 

  const onClick = useCallback(() => { 
    if(enabled) click?.();
  }, [click, enabled]);

  return (
    <button 
      className={[styles.button, className].join(' ')}
      ref={buttonRef}
      onClick={onClick} onMouseEnter={() => playAudio('audioCTAHover')}
      style={{ ...style}}
    >
      {children}
     
    </button>
  );
}